// Las claves YYYY-MM-DD representan días de calendario, no instantes UTC.
// Usamos UTC solo para recorrer el calendario sin depender del horario de verano.
const dayKey = (date) => date.toISOString().slice(0, 10);
const dayLabel = (date) => `${String(date.getUTCDate()).padStart(2, '0')}/${String(date.getUTCMonth() + 1).padStart(2, '0')}`;

const generateWeeks = (startDate, endDate) => {
  const weeks = [];
  const currentDate = new Date(`${startDate}T00:00:00Z`);
  const lastDate = new Date(`${endDate}T00:00:00Z`);
  const dayOfWeek = currentDate.getUTCDay();
  currentDate.setUTCDate(currentDate.getUTCDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));

  while (currentDate <= lastDate) {
    const monday = new Date(currentDate);
    const sunday = new Date(monday);
    sunday.setUTCDate(monday.getUTCDate() + 6);
    weeks.push({
      label: `${dayLabel(monday)} - ${dayLabel(sunday)}`,
      startDay: dayKey(monday),
      endDay: dayKey(sunday)
    });
    currentDate.setUTCDate(currentDate.getUTCDate() + 7);
  }
  return weeks;
};

const isDayInWeek = (day, week) => day >= week.startDay && day <= week.endDay;

module.exports = { generateWeeks, isDayInWeek };
